export default __webpack_public_path__ + "static/media/check.cc18be36.mp3";